import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import update from 'images/update.png';

const MainDiv = styled.div`
.updatePic{
    color: #00a465;
    cursor: pointer;
}
.floatUpdateDiv{
    display: flex;
    gap: 3%;
    margin-top: 8px;
}
`;

interface PreviewImgProps {
    id: string;
    style?: React.CSSProperties;
    imgUrl: string;
    showUpdateDiv: boolean;
    updateDiv?: React.ReactElement;
    cancelBtn?: any;
    onUpdateClick?: Function;
    disabled?: boolean;
}
const PreviewImg: React.FC<PreviewImgProps> = (props: PreviewImgProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <MainDiv>
            <div className={!isMobile ? "floatUpdateDiv" : ""}>
                <div className='posR'>
                    <img height="200px" width={isMobile ? "100%" : "278px"} src={props.imgUrl} style={props?.style}></img>
                    {props?.cancelBtn}
                </div>
                <br />
                {props?.showUpdateDiv && !props?.disabled && 
                <div className="updatePic" onClick={() => {
                    if(props?.onUpdateClick) props?.onUpdateClick() 
                    else (document.getElementById(props.id) as HTMLInputElement).click()
                }} >
                    {props?.updateDiv ? <>{props?.updateDiv}</> : <>{props?.imgUrl &&<>
                        <img src={update} alt="update" style={{ verticalAlign: "middle" }} ></img> &nbsp;
                        <span style={{ lineHeight: "1.4" }}>Update picture</span></>}</>
                    }
                </div>}
            </div>
        </MainDiv>
    )
};


export default PreviewImg;

